import { MessageCircle } from 'lucide-react';
export function InstructorMinimized({name,onRestore}:{name:string;onRestore:()=>void}){return <button className="mentor-minimized" onClick={onRestore} aria-label={`Restore ${name}, Pulkra Mentor`}><span>K</span><MessageCircle/><small>Mentor</small></button>}
